import { clearProjectContext } from '@/utils/projectContext'

export interface AuthInfo {
  accountCode?: string
  userId?: string
  userType?: 'root' | 'iam'
  loginId?: string
  /** 프로젝트 코드 (로그인 시 설정, 로그아웃까지 유지) */
  projectCode?: string
  /** 로그인 시 입력한 매장 아이디 (outletCode) */
  outletCode?: string
  /** 매장 코드 (로그인 응답에서 설정, API 호출에 사용) */
  shopCode?: string
  /** 매장명 (로그인 응답에서 설정, 로그아웃까지 유지) */
  shopName?: string
  /** 브랜드 코드 (로그인 응답에서 설정, 로그아웃까지 유지) */
  brandCode?: string
  isAuthenticated?: boolean
}

const AUTH_INFO_KEY = 'authInfo'

export const saveAuthInfo = (authInfo: AuthInfo): void => {
  localStorage.setItem(AUTH_INFO_KEY, JSON.stringify(authInfo))
}

export const getAuthInfo = (): AuthInfo | null => {
  try {
    const stored = localStorage.getItem(AUTH_INFO_KEY)
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

export const clearAuthInfo = (): void => {
  localStorage.removeItem(AUTH_INFO_KEY)
}

export const clearAllStoredData = (): void => {
  clearAuthInfo()
  clearProjectContext()
}

export const isLoggedIn = (): boolean => {
  return getAuthInfo() !== null
}
